import 'core-js/stable';
import 'regenerator-runtime/runtime';
import NovicellLazyLoad from 'novicell-lazyload';
import debounce from 'lodash/debounce';
import Vue from 'vue';
import 'array-from-polyfill';
import 'es6-object-assign/auto';
import objectFitImages from 'object-fit-images';

// This is the global JS file that will be accessible from any component

/* Atoms */
import '@/01-atoms/anchor-links/anchor-links';

/* Molecules */
import '@/02-molecules/navigation/navigation';
import '@/02-molecules/world-menu-mobile/world-menu-mobile';
import '@/02-molecules/_search-toggle/search-toggle';
import '@/02-molecules/_sidebar-trigger/sidebar-trigger';
import '@/02-molecules/sidebar/sidebar';

/* Organisms */
import '@/03-organisms/_backdrop/backdrop';
import '@/03-organisms/_burger-menu/burger-menu';
import '@/03-organisms/_search-overlay/search-overlay';
import '@/03-organisms/disclaimer-modal/disclaimer-modal';
import '@/03-organisms/grid-elements/accordion/accordion';
import '@/03-organisms/grid-elements/counting-up-numbers/counting-up-numbers';
import '@/03-organisms/grid-elements/eventbrite-event-embed/eventbrite-event-embed';
import '@/03-organisms/grid-elements/form/form';
import '@/03-organisms/grid-elements/funds-form-embed/funds-form-embed';
import '@/03-organisms/grid-elements/image-slideshow/image-slideshow';
import '@/03-organisms/grid-elements/inline-navigation/inline-navigation';
import '@/03-organisms/grid-elements/map/map';
import '@/03-organisms/grid-elements/hero/hero';
import '@/03-organisms/grid-elements/video/video';
import '@/03-organisms/grid-elements/logos-list/logos-list';
import '@/03-organisms/persistent-cta/persistent-cta';
import '@/03-organisms/static-risk-warning/static-risk-warning';

import '@/04-pages/events-form/events-form';

const lazy = new NovicellLazyLoad({
  includeWebp: true,
});

document.addEventListener(
  'lazybeforeunveil',
  (event) => {
    lazy.lazyLoad(event);
  },
  true,
);

// todo: check the call below. should the 100 not be part of the debounce argument list?
window.addEventListener(
  'resize',
  () => {
    debounce(lazy.checkImages);
  },
  100,
  false,
);

// Disable vue and change its config
if (process.env.NODE_ENV === 'production') {
  Vue.config.productionTip = false;
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
}

objectFitImages();
